import { Outlet } from "react-router-dom";
import { SidebarPraticienV2 } from "@/components/menu/SidebarPractitionerV2";
import { SidebarProvider } from "@/components/ui/sidebar";

export default function Practitioner() {
  return (
    <SidebarProvider>
    <SidebarPraticienV2 />
    <main className="w-full">
      <Outlet />
    </main>
  </SidebarProvider>
  );
}
